define('tracks/video-settings',["require", "exports", "../util/http", "./video-time"], function (require, exports, http_1, video_time_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.init = void 0;
    var videoUrlInput;
    var videoTimeInput;
    var modalVideoError;
    function init() {
        // Listen for video updates
        videoTimeInput = document.getElementById("video-time");
        videoUrlInput = document.getElementById("video-url");
        modalVideoError = document.querySelector("#modal-video .modal-error");
        var videoSaveButton = document.getElementById("video-save");
        if (videoSaveButton) {
            videoSaveButton.onclick = function () {
                var videoSettings = parse();
                if (videoSettings) {
                    var trackId = videoSaveButton.getAttribute("data-track-id");
                    var url = "/tracks/" + trackId + "/video";
                    // Post video to server
                    (0, http_1.postJson)(url, videoSettings).then(function () {
                        // TODO: Notify video player and dismiss modal
                        // $("#modal-video").modal("hide")
                        location.reload();
                    }).catch(function () {
                        modalVideoError.innerText = "Failed to save video";
                    });
                }
            };
        }
    }
    exports.init = init;
    /**
     * Parse video url and time inputs.
     * Validate and update ui while we're at it.
     */
    function parse() {
        // Clear state
        videoUrlInput.parentElement.classList.remove("has-error");
        videoTimeInput.parentElement.classList.remove("has-error");
        // Parse url
        var videoUrl = videoUrlInput.value.trim();
        if (!videoUrl) {
            // Special case for empty url
            return { videoUrl: videoUrl, videoTime: 0 };
        }
        if (!validateUrl(videoUrl)) {
            videoUrlInput.parentElement.classList.add("has-error");
            videoUrlInput.focus();
            modalVideoError.innerText = "Invalid video URL";
            return undefined;
        }
        // Parse time
        var videoTime = (0, video_time_1.parseTime)(videoTimeInput.value);
        if (isNaN(videoTime)) {
            videoTimeInput.parentElement.classList.add("has-error");
            videoTimeInput.focus();
            modalVideoError.innerText = "Invalid start time";
            return undefined;
        }
        return { videoUrl: videoUrl, videoTime: videoTime };
    }
    function validateUrl(videoUrl) {
        return videoUrl.startsWith("https://www.youtube.com/watch?v=")
            || videoUrl.startsWith("https://youtu.be/");
    }
});
//# sourceMappingURL=/assets/javascripts/tracks/video-settings.js.map;
